import React, { useEffect } from 'react';
import { loadIubenda } from './PrivacyPolicyLink';

//className: classi iubenda del link (di base il bottone nero; es. la landing lo vuole di solo testo)
const CookiePolicyLink = ({ className = "iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe" }) => {
  useEffect(() => {
    //un solo script iubenda anche per i due link insieme (vedi PrivacyPolicyLink)
    loadIubenda();
  }, []);

  return (
    <a
      href="https://www.iubenda.com/privacy-policy/15298448/cookie-policy"
      className={className}
      title="Cookie Policy"
    >
      Cookie Policy
    </a>
  );
};

export default CookiePolicyLink;
